<template>
  <div :class="['bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm overflow-hidden', className]">
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    className: { type: String, default: '' },
  },
}
</script>

